import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, Shield, User, ArrowLeft } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { cleanupAuthState } from '@/utils/authCleanup';

export function PendingApprovalPage() {
  const handleGoToSignIn = async () => {
    console.log('🔄 Forcing sign out and redirect to sign in');
    try {
      await supabase.auth.signOut();
    } catch (e) {
      // ignore
    } finally {
      cleanupAuthState();
      window.location.assign('/auth');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Clock className="w-8 h-8 text-primary" />
          </div>
          <CardTitle className="text-2xl">Access Request Pending</CardTitle>
          <CardDescription>
            Your account is awaiting admin approval. Please be patient while we review your request.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <User className="w-5 h-5 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">Registration Submitted</p>
                <p className="text-xs text-muted-foreground">Your request has been received</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3 p-3 bg-muted/20 rounded-lg opacity-60">
              <Shield className="w-5 h-5 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">Admin Review</p>
                <p className="text-xs text-muted-foreground">Waiting for approval</p>
              </div>
            </div>
          </div>
          
          <div className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              You'll receive access once an administrator approves your request. 
              This usually takes 1-2 business days.
            </p>
            
            <Button 
              type="button"
              variant="outline" 
              onClick={handleGoToSignIn}
              className="w-full"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Sign In
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}